import { render, staticRenderFns } from "./transactionlist.vue?vue&type=template&id=42c8bfab&scoped=true"
import script from "./transactionlist.vue?vue&type=script&lang=js"
export * from "./transactionlist.vue?vue&type=script&lang=js"
import style0 from "./transactionlist.vue?vue&type=style&index=0&id=42c8bfab&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c8bfab",
  null
  
)

export default component.exports